// extracted by mini-css-extract-plugin
export default {"description":"style_description__qp-yl","fade-in":"style_fade-in__QWab+","top":"style_top__TJ8CD","image":"style_image__k4gLy"};